import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { mergeStyles } from 'wix-rich-content-common';
import { officialEmotes } from './official-emotes';
import { DA_COMM_EMOTE } from './types';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
import styles from './emote-styles.scss';
const OfficialEmote = ({ decoratedText , children , themedStyles  })=>{
    const emote = officialEmotes[decoratedText.trim()];
    if (!emote) {
        return /*#__PURE__*/ React.createElement("span", null, children);
    }
    const emoteStyle = {
        backgroundImage: `url(https://e.deviantart.net/emoticons${emote.src})`,
        width: `${emote.width}px`,
        height: `${emote.height}px`,
        imageRendering: 'pixelated'
    };
    return /*#__PURE__*/ React.createElement("span", {
        className: themedStyles.emote,
        title: decoratedText,
        style: emoteStyle
    }, children);
};
OfficialEmote.displayName = 'OfficialEmote';
const CommunityEmote = ({ children , themedStyles , entity  })=>{
    if (!entity || !entity.getData) {
        return /*#__PURE__*/ React.createElement("span", null, children);
    }
    const { src , width , height , url , title  } = entity.getData();
    const emoteStyle = {
        backgroundImage: `url(${src})`,
        backgroundSize: 'contain',
        width: `${width}px`,
        height: `${height}px`,
        color: 'transparent'
    };
    return /*#__PURE__*/ React.createElement("a", {
        href: cleanLinkSrc(url),
        className: themedStyles.emote,
        title: title,
        style: emoteStyle
    }, children);
};
CommunityEmote.displayName = 'CommunityEmote';
const Emote = (props)=>{
    const themedStyles = mergeStyles({
        styles: styles,
        theme: props.theme
    });
    if (!props.entityKey) {
        return null;
    }
    const entity = props.contentState.getEntity(props.entityKey);
    if (entity && entity.getType() === DA_COMM_EMOTE) {
        return /*#__PURE__*/ React.createElement(CommunityEmote, _extends({}, props, {
            entity: entity,
            themedStyles: themedStyles
        }), props.children);
    }
    return /*#__PURE__*/ React.createElement(OfficialEmote, _extends({}, props, {
        themedStyles: themedStyles
    }), props.children);
};
Emote.displayName = 'Emote';
export default Emote;
